export default "__VITE_ASSET__BbchlLBp__"